import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import cart from "./cart";
import config from "./config";
export default new Vuex.Store({
  namespaced: true,
  state: {
    Products:undefined,
  },
  mutations: {
    GetWishList(state,data){
      state.Products = data
    }
  },
  actions: {
    getWishList({commit},data){
      commit("GetWishList",data)
    }
  },
  modules: {
    config,
    cart
  }
})
